import React, { useCallback } from 'react';
import { Button, Spin } from 'antd';
import { useViewerStore } from '../../../../../store/store';
import {
    openSiteViewer3dFromDashboard,
    startDeferredSiteProductionCalculations,
} from '../../../../../helpers/siteViewer3dAccess';

export interface DashboardRunAiBlockedStatusProps {
    message: string | null;
}

/** Inline status shown while Run AI is disabled during site or production calculations. */
export function DashboardRunAiBlockedStatus({ message }: DashboardRunAiBlockedStatusProps) {
    const siteViewerCalculationsPending = useViewerStore((s) => s.siteViewerCalculationsPending);
    const siteModelLoadInProgress = useViewerStore((s) => s.siteModelLoadInProgress);
    const deferredSiteModelLoad = useViewerStore((s) => s.deferredSiteModelLoad);

    const showStartActions =
        Boolean(siteViewerCalculationsPending || deferredSiteModelLoad) && !siteModelLoadInProgress;

    const handleStartCalculations = useCallback(() => {
        void startDeferredSiteProductionCalculations();
    }, []);

    const handleOpenOneDraw = useCallback(() => {
        openSiteViewer3dFromDashboard((next) => {
            useViewerStore.setState({ isDashboardOpen: next });
        });
    }, []);

    if (!message) return null;

    return (
        <div className="obd-ai-rail__run-blocked-status" role="status" aria-live="polite">
            <Spin size="small" aria-hidden />
            <span>{message}</span>
            {showStartActions ? (
                <span className="obd-ai-rail__run-blocked-actions">
                    <Button size="small" type="primary" onClick={handleStartCalculations}>
                        Start calculations
                    </Button>
                    <Button size="small" onClick={handleOpenOneDraw}>
                        Open oneDRAW
                    </Button>
                </span>
            ) : null}
        </div>
    );
}
